import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./ResultsTwo.module.scss";

import Tomatoes from "../../assets/png/Tomatoes.png";
import Radishes from "../../assets/png/Radishes.png";
import Bananas from "../../assets/png/Bananas.png";
import Eggplants from "../../assets/png/Eggplants.png";
import Flower from "../../assets/png/Flower.png";

export default class ResultsTwo extends Component {
  render() {
    return (
      <section id={styles.ResultsTwo}>
        <Image
          src={Flower}
          id={styles.Flower}
        ></Image>
        <Container fluid>
          <Row>
            <Col lg={6} className={styles.containerTop}>
              <p id={styles.FruitHeader1}>tomatoes</p>
              <Image
                src={Tomatoes}
                id={styles.Box1}
              ></Image>
              <p id={styles.FruitHeader2}>eggplants</p>
              <Image
                src={Eggplants}
                id={styles.Box2}
              ></Image>
            </Col>
            <Col lg={6} className={styles.containerBottom}>
              <p id={styles.FruitHeader3}>bananas</p>
              <Image
                src={Bananas}
                id={styles.Box3}
              ></Image>
              <p id={styles.FruitHeader4}>radishes</p>
              <Image
                src={Radishes}
                id={styles.Box4}
              ></Image>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
